import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { ProjectTechnology, TechnologyCollection, DatacenterProjectTechnology } from '@/features/projects/types';
import { DatacenterForm } from './datacenter-form';

export type DatacenterDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (
    collection: TechnologyCollection,
    item: DatacenterProjectTechnology,
    description?: string
  ) => void;
  readonly onClose: () => void;
};

export function DatacenterDrawer({ formId, technology, isOpen, onSubmit, onClose }: DatacenterDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Data Center Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <DatacenterForm
        id={formId}
        item={technology?.item as DatacenterProjectTechnology}
        onSubmit={(data: any) =>
          onSubmit(
            'projects_datacenter_technologies',
            { ...technology?.item, ...data },
            t('Data Center Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
